import styled from 'styled-components'

export const Ocultar = styled.div`
  display: none;
`
